import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import TicketReport from "../User/TicketReport";
import MyTickets from "./MyTickets";
import { DecryptED } from "../../DecryptJS/Decrypt";

// Admin's landing route shows different UI depending on whether the
// visitor has a real staff record at this school:
//  - Real staff member (any committee/type, e.g. Head of School) -> the
//    existing "Admin Dashboard" card view (MyTickets.js).
//  - No matching staff record (e.g. a generic/shared login like
//    "SCHOOL ADMINISTRATOR") -> the Reports/List view, which is already
//    scoped to just their own created tickets for this case.
export default function Dashboard() {
  const { sid, uid } = useParams();
  const [loading, setLoading] = useState(true);
  const [isRestrictedAdmin, setIsRestrictedAdmin] = useState(false);

  useEffect(() => {
    axios.post("https://topschool.prisms.in/rest/index.php/user_list.json?", {
      fun_name: "GetStaffDetails",
      sid: sid,
    }, { timeout: 20000 }).then((res) => {
      var staffList = res.data && Array.isArray(res.data.Staff_Details) ? res.data.Staff_Details : [];
      var decUid;
      try { decUid = DecryptED(uid); } catch (e) { decUid = ""; }
      var hasStaffRecord = staffList.some(function(s) { return String(s.staff_id) === String(decUid); });
      setIsRestrictedAdmin(!hasStaffRecord);
      setLoading(false);
    }).catch(() => {
      // Fail open — don't send a real admin to the restricted view over a network hiccup.
      setIsRestrictedAdmin(false);
      setLoading(false);
    });
  }, [sid, uid]);

  if (loading) return null;
  return isRestrictedAdmin ? <TicketReport /> : <MyTickets />;
}
